import { Compass, Lock, PowerOff, Smartphone } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { buttonClass, EmptyState, ErrorState } from '@/components/ui';
import { useT } from '@/i18n';

/** Errors thrown while rendering or loading a route chunk (e.g. a deploy replaced the chunk). */
export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  return (
    <div className="grid min-h-[60dvh] place-items-center">
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}

export function NotFoundPage() {
  const t = useT();
  return (
    <EmptyState
      icon={Compass}
      title={t('error.notFoundTitle')}
      body={t('error.notFoundBody')}
      action={
        <Link to="/" className={buttonClass('primary')}>
          {t('error.goHome')}
        </Link>
      }
    />
  );
}

export function FeatureOffPage() {
  const t = useT();
  return <EmptyState icon={PowerOff} title={t('error.featureOffTitle')} body={t('error.featureOffBody')} action={<Link to="/" className={buttonClass('secondary')}>{t('error.goHome')}</Link>} />;
}

/** A teacher whose school has attendance switched off: nothing on the web for them. */
export function TeacherOffPage() {
  const t = useT();
  return <EmptyState icon={Smartphone} title={t('attendance.teacherOff.title')} body={t('attendance.teacherOff.body')} />;
}

export function ForbiddenPage() {
  const t = useT();
  return <EmptyState icon={Lock} title={t('error.forbiddenTitle')} action={<Link to="/" className={buttonClass('secondary')}>{t('error.goHome')}</Link>} />;
}
